import React from "react";
import { Verdict } from "../../types";
import { ratingForScore, BAND_COLOR, BAND_FILTER } from "../../office/scoreBand";
import styles from "./BigScoreCard.module.css";

interface BigScoreCardProps {
  score: number;
  verdict: Verdict;
  issuesFound: number;
}

const GAUGE_URL = "assets/score-gauge.png";

export default function BigScoreCard({ score, issuesFound }: BigScoreCardProps) {
  const rating = ratingForScore(score);
  const band = rating.band;
  const accent = BAND_COLOR[band];
  const hasIssues = issuesFound > 0;

  return (
    <div className={styles.card}>
      <div className={styles.topSection}>
        <div className={styles.leftCol}>
          <p className={styles.label}>TRUSTED PARTNER SCORE</p>
          <div className={styles.gaugeWrap}>
            <img
              src={GAUGE_URL}
              alt=""
              aria-hidden="true"
              className={styles.gaugeImg}
              style={{ filter: BAND_FILTER[band] }}
            />
            <div className={styles.gaugeNumberWrap}>
              <span className={styles.gaugeNumberInner}>
                <span className={styles.gaugeNumber} style={{ color: accent }}>
                  {score}
                </span>
                <span className={styles.gaugeOutOf}>/100</span>
              </span>
            </div>
          </div>
        </div>

        <div className={styles.rightCol}>
          {hasIssues && (
            <span className={styles.issuesPill}>
              <svg width="9" height="11" viewBox="0 0 9 11" fill="currentColor" aria-hidden="true">
                <path d="M0 0v11h1.5V7H9l-2-3.5L9 0H0z" />
              </svg>
              ISSUES FOUND
            </span>
          )}
          <div className={styles.verdictBlock}>
            <p className={styles.verdictHeadline}>{rating.label}</p>
            {hasIssues && (
              <p className={styles.verdictSub}>
                {issuesFound}{" "}
                <span className={styles.verdictSubFaint}>
                  Recommendation{issuesFound === 1 ? "" : "s"} for Enhancement
                </span>
              </p>
            )}
          </div>
        </div>
      </div>

      <div className={styles.bottomSection}>
        <div className={styles.rangeRow}>
          <span className={styles.rangeMin}>0</span>
          <span className={styles.rangeLabel}>SCORE RANGE</span>
          <span className={styles.rangeMax}>100</span>
        </div>
        <div className={styles.rangeBar}>
          <div
            className={styles.rangeFill}
            style={{
              width: `${score}%`,
              background: `linear-gradient(90deg, ${accent}80, ${accent})`,
            }}
          >
            <span className={styles.rangeCap} style={{ background: accent, boxShadow: `0 0 8px ${accent}` }} />
          </div>
        </div>
      </div>
    </div>
  );
}
